// Ce fichier est maintenant un simple wrapper autour de l'utilitaire themeManager
import React, { createContext, useState, useContext, useEffect } from 'react';
import { getTheme, toggleTheme } from '../utils/themeManager';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(getTheme);
  
  useEffect(() => {
    const handleThemeChange = (e) => {
      setTheme(e.detail || getTheme());
    };
    
    window.addEventListener('themeChanged', handleThemeChange);
    return () => {
      window.removeEventListener('themeChanged', handleThemeChange);
    };
  }, []);
  
  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};